import type { CancelablePromise } from '/src/api';
import { OpenAPI, request as __request } from '/src/api';
import { ForkliftClassification } from '/src/lib/models/ForkliftClassification';

export class ForkliftClassificationService {
  /**
   * List Forklift Classifications
   * @returns ForkliftClassifications[]
   * @throws ApiError
   */
  public static listForkliftClassifications(): CancelablePromise<ForkliftClassification[]> {
    return __request(OpenAPI, { method: 'GET', url: '/forkliftClassifications' });
  }
}
